import {roleList,getMenu,getUserPermission,batchSavePermission,addRole,upRole,batchaDelRole} from 'api/role';
import Cookies from 'js-cookie';

const role = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        roleList({commit},params) {
            return new Promise((resolve, reject) => {
                var roleName = params.roleName;
                var psize = params.psize;
                var currentPage = params.currentPage;
                roleList(roleName,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getMenu({commit},roleId) {
            return new Promise((resolve, reject) => {
                getMenu(roleId).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getUserPermission({commit}) {
            return new Promise((resolve, reject) => {
                getUserPermission().then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchSavePermission({commit},params) {
            return new Promise((resolve, reject) => {
                batchSavePermission(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        addRole({commit},params) {
            return new Promise((resolve, reject) => {
                addRole(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        upRole({commit},params) {
            return new Promise((resolve, reject) => {
                upRole(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchaDelRole({commit},params) {
            return new Promise((resolve, reject) => {
                batchaDelRole(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default role;



// WEBPACK FOOTER //
// ./src/store/modules/role.js